<ps-ui-modal size="lg" buttonClosePosition="top">
  <h5 psUiModalTitle class="px-4"><b>Notifications Sent</b></h5>
  <p psUiModalSubtitle class="px-4">{{ date }}</p>

  <ps-ui-modal-body class="px-3">
    <section class="via-email px-4">
      <header>
        <i class="fa fa-envelope"></i>
        <h6><b>Via Email</b></h6>
      </header>

      <div class="emails">
        <p *ngFor="let email of emails">{{ email }}</p>

        <ng-template [ngIf]="!emails.length">
          <p class="no-value-message">
            No Subscriber Email configured. If you want to be notified, please
            add a valid email address in the Subscriber Email field on the Final
            details page.
          </p>
        </ng-template>
      </div>
    </section>
  </ps-ui-modal-body>
</ps-ui-modal>
